module.exports = __webpack_public_path__ + "static/img/logo-7xc.69c08fa2.png";